import DisplayLine from './DisplayLine';
import Errors from './Errors';
import { Flex, Stack } from './layouts';
import styled from '@emotion/styled';
import RadioOption from './RadioOption';
import WithLabel from "./WithLabel";
import {FC} from "react";

export interface RadioProps {
  value?: any;
  columns: string[];
  rows: string[];
  onChange?: (e: (any)) => void;
  errors?: string[] | boolean;
  readOnly?: boolean;
  label?: string;
  name: string;
}

const GridTable = styled('table')`
  width: 100%;
  table-layout: fixed;
  border-spacing: 4px;
  tr {
    margin: 8px 0;
    height: 24px;
    > * {
      &:first-of-type {
        width: 40%;
      }
    }
    th {
      font-weight: normal;
    }
  }
`;

const RadioGrid: FC<RadioProps> = ({
  value,
  onChange,
  errors,
  readOnly,
  columns,
  rows,
  label,
  name
}) => {
  if (readOnly) {
    return (
      <WithLabel label={label}>
        <Stack space={'s'}>
          {rows.map((row) => {
            const rowValue = value?.[row];
            return <DisplayLine key={row} label={row} value={rowValue} />;
          })}
        </Stack>
      </WithLabel>
    );
  }

  const input = (
    <>
      <GridTable>
        <thead>
          <tr>
            <th />
            {columns.map((column) => (
              <th key={`${name}-${column}`}>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            return (
              <tr key={`${name}-${row}`}>
                <td>{row}</td>
                {columns.map((column) => {
                  const rowValue = value?.[row];
                  return (
                    <td key={`${name}-${row}_${column}`}>
                      <Flex justifyContent={'center'} alignItems={'center'}>
                        <RadioOption
                          label={false}
                          value={column}
                          name={`${name}-${row}`}
                          onChange={(changeValue) => {
                            const newValue = {
                              ...value,
                              [row]: changeValue,
                            };
                            onChange(newValue);
                          }}
                          checked={rowValue === column}
                        />
                      </Flex>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </GridTable>
      {errors && <Errors errors={errors} />}
    </>
  );

  return label ? <WithLabel label={label} asDiv>{input}</WithLabel> : input;
};

export default RadioGrid;
